import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const alertVariants = cva(
  "relative w-full rounded-lg border px-4 py-3 text-body-sm [&>svg+div]:translate-y-[-2px] [&>svg]:absolute [&>svg]:left-4 [&>svg]:top-4 [&>svg~*]:pl-7",
  {
    variants: {
      variant: {
        // Cada variante con su par oscuro: era el primitivo sin modo oscuro más usado (~70 avisos).
        default: "bg-card border-line text-foreground [&>svg]:text-subtle",
        info: "bg-info-50 border-info/30 text-primary-900 [&>svg]:text-info dark:bg-info/10 dark:text-info-200",
        success: "bg-success-50 border-success/30 text-success-700 [&>svg]:text-success dark:bg-success/10 dark:text-success-200",
        warning: "bg-warning-50 border-warning/30 text-warning-700 [&>svg]:text-warning dark:bg-warning/10 dark:text-warning-200",
        destructive:
          "bg-danger-50 border-danger/30 text-danger-700 [&>svg]:text-danger dark:bg-danger/10 dark:text-danger-200",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

const Alert = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement> & VariantProps<typeof alertVariants>
>(({ className, variant, ...props }, ref) => (
  <div
    ref={ref}
    role="alert"
    className={cn(alertVariants({ variant }), className)}
    {...props}
  />
))
Alert.displayName = "Alert"

const AlertTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, ...props }, ref) => (
  <h5
    ref={ref}
    className={cn("mb-1 font-semibold leading-none tracking-tight", className)}
    {...props}
  />
))
AlertTitle.displayName = "AlertTitle"

const AlertDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn("text-body-sm [&_p]:leading-relaxed", className)}
    {...props}
  />
))
AlertDescription.displayName = "AlertDescription"

export { Alert, AlertTitle, AlertDescription }
